import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { blockConfig } from '../../../config';

const AfterHoursWrapper = styled.div`
  left: calc(
    ${p => p.left}% +
      ${p =>
    // eslint-disable-next-line
    p.amountDay * p.widthDayBreaker - p.widthDayBreaker / 1.3}px
  );
  top: calc(50% - 7px);
  position: absolute;
  &::before {
    content: '';
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid ${p => p.color};
    position: absolute;
    margin-left: 5px;
  }
  &::after {
    content: '';
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid ${p => p.color};
    position: absolute;
  }
`;

const BlockAfterHours = ({ block, view }) => {
  const getStatusColor = (type = 'colorMain') => {
    if (
      block &&
      Object.keys(block).length &&
      block.alert &&
      blockConfig.alert[block?.alert?.level]
    ) {
      return blockConfig.alert[block?.alert?.level][type];
    }
    return blockConfig.alert.none[type];
  };

  return (
    <AfterHoursWrapper
      color={getStatusColor()}
      left={block.left}
      amountDay={block.amountDay}
      widthDayBreaker={view?.parameters?.widthDayBreaker}
    />
  );
};

BlockAfterHours.propTypes = {
  block: PropTypes.object.isRequired,
  view: PropTypes.object,
};

export default BlockAfterHours;
